import { gql } from "@apollo/client";
import { STAFF_MANAGEMENT_WORK_SESSION_LOG_SNAPSHOT_FRAGMENT } from "../query/staff-management-gql";


export const STAFF_MANUAL_CHECKOUT_SESSION_FRAGMENT = gql`
    ${ STAFF_MANAGEMENT_WORK_SESSION_LOG_SNAPSHOT_FRAGMENT }

    fragment StaffManualCheckoutSession on WorkSession {
        id
        user_id
        ee_id
        check_in_at
        check_out_at
        getWorkedHours
        getCheckOutStatus
        relCheckOutLog {
            ...StaffManagementWorkSessionLogSnapshot
        }
    }
`;

export const WORK_SESSION_MANUAL_CHECKOUT = gql`
    ${ STAFF_MANUAL_CHECKOUT_SESSION_FRAGMENT }

    mutation WorkSessionManualCheckout($id: ID!) {
        workSessionManualCheckout(id: $id) {
            label
            message
            workSession {
                ...StaffManualCheckoutSession
            }
        }
    }
`;


export const WORK_SESSIONS_EXPORT_EXCEL = gql`
    mutation WorkSessionsExportExcel($eeID: ID!) {
        workSessionsExportExcel(ee_id: $eeID) {
            label
            message
            file
        }
    }
`;
